import { Modal } from "@mantine/core";
import { FaHandHoldingDollar } from "react-icons/fa6";
import { BiLoaderAlt } from "react-icons/bi";
import { useState } from "react";
import { affiliateWithdrawUpdate } from "../../stores/actions/affiliate.actions.types";
import { connect } from "react-redux";
import { TextEditorInput } from "../UI/FormField";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { useTranslation } from "react-i18next";
import { successMessage } from "../../utilities/notification";

const WithdrawPay = ({
  affiliateWithdrawUpdate,
  opened,
  setOpend,
  title,
  setReload,
  reload,
  id,
}) => {
  const [paymentPaidLoading, setPaymentPaidLoading] = useState(false);
  const [paymentRejectLoading, setPaymentRejectLoading] = useState(false);
  const [showRejectForm, setShowRejectForm] = useState(false);
  const { t } = useTranslation();

  const close = () => {
    setOpend(false);
    setShowRejectForm(false);
  };

  const handleSubmit = async (values) => {
    const isPaid = values.status === "paid";
    if (isPaid) {
      setPaymentPaidLoading(true);
    } else {
      setPaymentRejectLoading(true);
    }

    affiliateWithdrawUpdate({
      id,
      data: values,
      callback: (data) => {
        if (data.success) {
          setOpend(false);
          successMessage("Success");
          setReload(!reload);
        }
        setPaymentPaidLoading(false);
        setPaymentRejectLoading(false);
      },
    });
  };

  return (
    <Modal
      centered
      opened={opened}
      size={"lg"}
      onClose={close}
      title={title}
      overlayProps={{ backgroundOpacity: 0.1 }}
    >
      {!showRejectForm && (
        <div className='my-8 text-center'>
          <FaHandHoldingDollar className='sm:text-6xl m-auto text-3xl' />
          <h4 className='mt-4 text-lg font-semibold text-gray-800'>
            Confirm Payment
          </h4>
        </div>
      )}

      {!showRejectForm ? (
        <div className='flex flex-col space-y-2'>
          <div className='flex gap-3'>
            <button
              type='button'
              onClick={() => handleSubmit({ status: "paid" })}
              disabled={paymentPaidLoading}
              className='rounded-lg w-full bg-green-500 px-4 py-2 text-sm tracking-wide text-white hover:bg-green-600 active:bg-green-500'
            >
              {paymentPaidLoading ? (
                <BiLoaderAlt className='m-auto animate-spin text-xl text-white' />
              ) : (
                "Pay"
              )}
            </button>

            <button
              type='button'
              onClick={() => setShowRejectForm(true)}
              className='rounded-lg w-full bg-red-500 px-4 py-2 text-sm tracking-wide text-white hover:bg-red-600 active:bg-red-500'
            >
              Reject
            </button>
          </div>
          <button
            type='button'
            onClick={close}
            className='rounded-lg bg-gray-200 px-4 py-2 text-sm tracking-wide text-gray-800 hover:bg-gray-300 active:bg-gray-200'
          >
            Cancel
          </button>
        </div>
      ) : (
        <Formik
          initialValues={{ rejectionReason: "" }}
          validationSchema={Yup.object({
            rejectionReason: Yup.string()
              .required("Rejection reason is required")
              .min(10, "Too short. Write at least 10 characters."),
          })}
          onSubmit={(values) =>
            handleSubmit({
              status: "rejected",
              rejectionReason: values.rejectionReason,
            })
          }
        >
          {({ isSubmitting }) => (
            <Form className='flex flex-col space-y-4'>
              <div>
                <h4 className='mb-2 text-lg font-semibold text-gray-800 text-center'>
                  {t("Write the reason of rejection")}
                </h4>
                <TextEditorInput
                  label={t("Rejection Reason")}
                  id='rejectionReason'
                  rows={6}
                  name='rejectionReason'
                  placeholder='Enter rejection note'
                  className='block w-full text-black dark:text-white rounded-md border px-3 py-2 dark:bg-black'
                />
              </div>

              <div className='flex gap-3'>
                <button
                  type='submit'
                  disabled={paymentRejectLoading || isSubmitting}
                  className='rounded-lg w-full bg-red-500 px-4 py-2 text-sm tracking-wide text-white hover:bg-red-600 active:bg-red-500 disabled:opacity-50'
                >
                  {paymentRejectLoading ? (
                    <BiLoaderAlt className='m-auto animate-spin text-xl text-white' />
                  ) : (
                    "Confirm Reject"
                  )}
                </button>

                <button
                  type='button'
                  onClick={() => setShowRejectForm(false)}
                  className='rounded-lg w-full bg-gray-300 px-4 py-2 text-sm tracking-wide text-gray-800 hover:bg-gray-400'
                >
                  Back
                </button>
              </div>
            </Form>
          )}
        </Formik>
      )}
    </Modal>
  );
};

const mapStateToProps = (state) => ({
  loading: state?.app?.visible,
});

export default connect(mapStateToProps, { affiliateWithdrawUpdate })(
  WithdrawPay
);
